import { useState } from 'react'
import { Activity, Download, Trash2, Eye, Shield } from 'lucide-react'

export default function SecurityPrivacySettings({ subMenu }) {
  const [activities] = useState([
    { id: 1, action: 'Connexion', date: new Date(), ip: '192.168.1.1', device: 'Chrome sur Windows' },
    { id: 2, action: 'Modification du profil', date: new Date(Date.now() - 3600000), ip: '192.168.1.1', device: 'Chrome sur Windows' },
    { id: 3, action: 'Ajout d\'un utilisateur', date: new Date(Date.now() - 7200000), ip: '192.168.1.1', device: 'Chrome sur Windows' }
  ])

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date)
  }

  if (subMenu === 'activity') {
    return (
      <div className="space-y-6">
        <div className="card">
          <div className="card-header">
            <div>
              <h3 className="card-title">Historique d'activité</h3>
              <p className="card-subtitle">Consultez l'historique de vos actions</p>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Date</th>
                  <th>Adresse IP</th>
                  <th>Appareil</th>
                </tr>
              </thead>
              <tbody>
                {activities.map((activity) => (
                  <tr key={activity.id}>
                    <td className="font-medium">{activity.action}</td>
                    <td className="text-muted">{formatDate(activity.date)}</td>
                    <td className="text-muted font-mono text-sm">{activity.ip}</td>
                    <td className="text-muted">{activity.device}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  if (subMenu === 'privacy') {
    return (
      <div className="space-y-6">
        <div className="card">
          <div className="card-header">
            <div>
              <h3 className="card-title">Données personnelles</h3>
              <p className="card-subtitle">Gérez vos données et votre confidentialité</p>
            </div>
          </div>
        </div>

        {/* Export des données */}
        <div className="card">
          <div className="p-6">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Download className="h-5 w-5 text-blue-600" />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-gray-900 mb-1">Exporter vos données</h4>
                <p className="text-sm text-muted mb-4">
                  Téléchargez une copie de toutes vos données personnelles
                </p>
                <button className="btn btn-primary-outline">
                  <Download className="h-4 w-4" />
                  Exporter mes données
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Suppression du compte */}
        <div className="card border-red-200 bg-red-50">
          <div className="p-6">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Trash2 className="h-5 w-5 text-red-600" />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-red-900 mb-1">Supprimer mon compte</h4>
                <p className="text-sm text-red-700 mb-4">
                  Cette action est irréversible. Toutes vos données seront définitivement supprimées.
                </p>
                <button className="btn btn-danger">
                  <Trash2 className="h-4 w-4" />
                  Supprimer définitivement mon compte
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}
